import React from "react";

import type { Rect } from "./edgeLabelPlacement";

/**
 * Where the cards currently are, in flow coordinates.
 *
 * Published by `ContextGraphCanvas` from its live node state and read by every
 * edge, so a relation label can dodge the cards without the layout freezing a
 * position that a dragged card would immediately invalidate. Empty by default:
 * an edge rendered outside the canvas simply has nothing to avoid.
 */
export const CardRectsContext = React.createContext<readonly Rect[]>([]);
